export default __webpack_public_path__ + "static/media/avatar.8ac7239d.png";